module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-wrap",
    class: {
      'component-padded': _vm.base.padded, 'active': _vm.active
    }
  }, [_c('div', {
    staticClass: "current-active"
  }), _vm._v(" "), (_vm.base.title) ? _c('div', {
    staticClass: "component-header"
  }, [_c('div', {
    staticClass: "component-title"
  }, [_c('div', [_vm._v(_vm._s(_vm.base.title))]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.base.subtitle))])]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "slider-wrap",
    class: {
      'padded': _vm.config.padded
    }
  }, [_c('img', {
    staticClass: "scale-placeholder",
    attrs: {
      "src": _vm.data[0] && _vm.data[0].imgUrl || 'https://fakeimg.pl/320x240/EFEFEF/CCC/?text=image&font=lobster'
    }
  }), _vm._v(" "), _c('el-carousel', {
    staticClass: "sliderimg",
    attrs: {
      "indicator-position": "none",
      "arrow": "never",
      "height": '100%',
      "interval": _vm.config.interval
    },
    on: {
      "change": _vm.change
    }
  }, _vm._l((_vm.data), function(item, index) {
    return _c('el-carousel-item', {
      key: index,
      staticClass: "slider-item",
      class: {
        'rounded': _vm.config.rounded
      }
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": item.imgUrl || 'https://fakeimg.pl/320x' + _vm.config.height + '/EFEFEF/CCC/?text=image&font=lobster'
      }
    })])])
  }), 1), _vm._v(" "), (_vm.config.dot && _vm.data.length > 1) ? _c('div', {
    staticClass: "slider-dot",
    class: [_vm.config.animation ? 'dot-size-switch' : '', _vm.config.dotLocation, _vm.config.dotCover ? 'cover' : 'no-cover', _vm.config.dotColor, _vm.config.shape]
  }, _vm._l((_vm.data), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "dot",
      class: {
        'active': _vm.config.current == index
      }
    })
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.config.dot && _vm.data.length > 1) ? _c('div', {
    staticClass: "slider-count",
    class: [_vm.config.dotLocation, _vm.config.shape, _vm.config.dotColor]
  }, [_vm._v(_vm._s(_vm.config.current + 1) + "/" + _vm._s(_vm.data.length))]) : _vm._e()], 1), _vm._v(" "), (_vm.config.content && _vm.data.length > 0 && _vm.data[_vm.config.current].content) ? _c('div', {
    staticClass: "slider-caption"
  }, [_vm._v("\n    " + _vm._s(_vm.data[_vm.config.current].content) + "\n  ")]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-more"
  }, [_c('div', {
    staticClass: "three-dot"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-fc40ea38", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fc40ea38"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/slider.vue
// module id = 2997
// module chunks = 0